// extracted by mini-css-extract-plugin
export default {"channelInitialIcon":"ChannelInitialIcon_channelInitialIcon__cMOwT"};